<template>
  <div id="app" v-loading="loading">
    <template v-if="!loading">
      <template v-if="setting.layout === 'base' && $route.path !== '/login'">
        <base-layout></base-layout>
      </template>
      <template v-if="setting.layout === 'topMenu' && $route.path !== '/login'">
        <topmenu-layout></topmenu-layout>
      </template>
      <template v-if="$route.path === '/login'">
        <router-view name="content"></router-view>
        <!-- <div class="utear-layout-footer">
          <router-view name='footer'></router-view>
        </div> -->
      </template>
    </template>
  </div>
</template>

<script>
import TopmenuLayout from '@/layout/TopmenuLayout'
import BaseLayout from '@/layout/BaseLayout'
import setting from '@/defaultSetting.json'
import { keycloakInit } from '@/assets/js/keycloak.js'
import { getPermission } from '@/assets/js/http.js'
// import verifyFn from '@/assets/js/routePermission'
export default {
  name: 'App',
  data () {
    return {
      setting,
      loading: true
    }
  },
  components: {
    TopmenuLayout,
    BaseLayout
  },
  async mounted () {
    await keycloakInit
    const data = await getPermission()
    this.$store.commit('setPermiList', data)
    const { allPermiList } = this.$store.getters
    // eslint-disable-next-line no-undef
    const sysKey = BUILD_ENV === 'ali' ? 'argus-ali-admin' : 'argus-admin'
    if (!allPermiList.includes(sysKey)) {
      this.$router.push('/401')
    }
    this.loading = false
    this.$http.get('/login.htm')
  }
}
</script>
<style>
html,
body,
#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
